import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import { getUserPermissions } from 'dashboard/helper/permissionsHelper';
import { useTeletelFeatures } from 'dashboard/composables/useTeletelFeatures';

// Tab sets for pages that belong together. Each tab carries the same rule the
// sidebar uses for its entry, so a tab never offers a page the viewer cannot
// open (the server enforces the real rule either way).
export function useTeletelPageTabs() {
  const { t } = useI18n();
  const getters = useStoreGetters();
  const { isTeletelFeatureEnabled } = useTeletelFeatures();

  const isAdministrator = computed(
    () => getters.getCurrentRole.value === 'administrator'
  );
  const can = permission =>
    isAdministrator.value ||
    getUserPermissions(
      getters.getCurrentUser.value,
      getters.getCurrentAccountId.value
    ).includes(permission);

  const integrationTabs = computed(() => [
    { name: 'settings_applications', label: t('SIDEBAR.INTEGRATIONS') },
    ...(isAdministrator.value
      ? [
          {
            name: 'teletel_integration_controls',
            label: t('TELETEL_INTEGRATIONS.TITLE'),
          },
        ]
      : []),
  ]);

  const lifecycleTabs = computed(() => {
    if (!isTeletelFeatureEnabled('lifecycle')) return [];
    return [
      can('contact_manage') && {
        name: 'contacts_lifecycle_board',
        label: t('TELETEL_LIFECYCLE.BOARD.SIDEBAR_LABEL'),
      },
      can('report_manage') && {
        name: 'lifecycle_reports',
        label: t('TELETEL_LIFECYCLE.REPORTS.SIDEBAR_LABEL'),
      },
      can('lifecycle_manage') && {
        name: 'teletel_lifecycle_settings',
        label: t('TELETEL_LIFECYCLE.SETTINGS.SIDEBAR_LABEL'),
      },
    ].filter(Boolean);
  });

  const canViewTeamPresence = computed(
    () => isTeletelFeatureEnabled('team_presence') && can('team_presence_view')
  );

  return { integrationTabs, lifecycleTabs, canViewTeamPresence };
}
